const steps = [
  {
    step: "1",
    title: "Choose Your Service & Processing Speed",
    description: "Select the passport service you need (new, renewal, lost, child, etc.) and your preferred timeline — 2–9 days or 24-hour emergency.",
  },
  {
    step: "2",
    title: "Complete Your Application Online",
    description: "Fill out our secure online application. A dedicated agent reviews your information for accuracy before we proceed.",
  },
  {
    step: "3",
    title: "Ship Your Documents to Our Office",
    description: "Send your application, photos, and supporting documents to our registered office via overnight shipping. We accept shipments from Anchorage, Wasilla, Eagle River, and all Alaska.",
  },
  {
    step: "4",
    title: "We Submit at a U.S. Passport Agency",
    description: "Your dedicated agent hand-delivers your application at a U.S. Department of State passport agency with reserved courier access.",
  },
  {
    step: "5",
    title: "Receive Your Passport Fast — Guaranteed",
    description: "Your new passport is shipped back to Anchorage via secure overnight delivery. Track every step of the way with daily agent updates.",
  },
];

export default function HowItWorksSection() {
  return (
    <section id="how-it-works" className="bg-[#1A365D] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">How It Works</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-4">
            5 Steps to Your Passport — From Anchorage
          </h2>
          <p className="text-white/60 max-w-2xl mx-auto text-base leading-relaxed">
            Our streamlined process is designed to eliminate confusion, avoid delays, and get your passport in your hands as fast as possible.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
          {steps.map((s, i) => (
            <div key={i} className="relative text-center">
              {i < steps.length - 1 && (
                <div className="hidden md:block absolute top-8 left-[60%] w-[80%] h-0.5 bg-white/10"></div>
              )}
              <div className="w-16 h-16 mx-auto rounded-full bg-[#F6C344] flex items-center justify-center mb-5 relative z-10">
                <span className="text-[#1A365D] font-bold text-lg">{s.step}</span>
              </div>
              <h3 className="font-bold text-white text-sm mb-2">{s.title}</h3>
              <p className="text-white/50 text-sm leading-relaxed">{s.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}